
    import { defineComponent, onMounted, reactive, ref } from "vue";
    import {fetList} from "@/api/subuser"
    import {
        taskPage,
        taskDetail,
        exeTask,
        exeForward,
        downTaskVillages,
        downTaskItems,
        downTask
    } from "@/api/task";
    import {useStore} from "vuex";
    import { VxeColumnPropTypes, VxeFormPropTypes } from "vxe-table";
    import { ElLoading, ElMessage } from "element-plus";
    import { config } from "@/utils/config"; //引入公用文件
    import { indexOf } from "xe-utils";
    import XEUtils from "xe-utils";
    import { VXETable, VxeTableInstance, VxeTableEvents } from 'vxe-table'

    export default defineComponent({
        setup() {
            let canSubmit:boolean = !window.sessionStorage.getItem("subUserId");
            let userCompType:string = window.sessionStorage.getItem("compType")||'';
            const store=useStore();
            //   列表
            const table = reactive({
                loading: false,
                tableData: [] as any[],
            });

            const formatTime: VxeColumnPropTypes.Formatter = ({ cellValue }) => {
                return XEUtils.toDateString(cellValue, "yyyy-MM-dd HH:mm:ss");
            };
            const formatState: VxeColumnPropTypes.Formatter = ({
                                                                   cellValue,
                                                                   row,
                                                                   column,
                                                               }) => {
                if (cellValue === 1) return "未上报";
                if (cellValue === 2) return "已上报";
                if (cellValue === 3) return "暂存上报";
                if (cellValue === 4) return "整改";
                return cellValue;
            };
            const formatSubUserList:VxeColumnPropTypes.Formatter = ({ cellValue })=>{
                if(cellValue){
                   return  cellValue.map((item:any) =>item.deptName).join(';');
                };
                return "--";
            };
            onMounted(() => {
                initSubUserList();
                getTableData();
                if(userCompType === '0604'|| userCompType === '0603')initVillageList();
            });
            const pageChange = (args: any) => {
                page.pageSize = args.pageSize;
                page.currentPage = args.currentPage;
                getTableData();
            };
            // 分页
            interface PageValue {
                currentPage: Number;
                pageSize: Number;
                totalResult: Number;
            }
            let page: PageValue = reactive({
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            });
            let getTableData = () => {
                table.loading = true;
                taskPage({
                    size: page.pageSize,
                    current: page.currentPage,
                }).then((res: any) => {
                    table.tableData = res.data.records;
                    page.totalResult = res.data.total;
                    table.loading = false;
                });
            };
            let editConfig:any = {
                tableData: [],
                taskMedicalId: null,
                updateRemark:'' as string,
                editable:false
            };
            let showModal = ref(false)
            let fullScreen = ref(true)
            let xTable1 = ref(null);
            const editEvent = (row: any) => {
                editConfig.taskMedicalId = row.id;
                editConfig.updateRemark = row.updateRemark || '';
                editConfig.editable = true;
                taskDetail(row.id).then((resonse: any) => {
                    let records:any[] = resonse.data;
                    for (let i = 0; i < records.length; i++) {
                        filesConfig[ records[i]['id'] ] = records[i]['attachmentList'];
                        updateFilesConfig[ records[i]['id'] ] = records[i]['updateAttachmentList'];
                    }
                    delFilesConfig = [];
                    editConfig.tableData = records;
                    fullScreen.value = true
                    showModal.value = true
                });
            };

            const viewEvent = (row: any) => {
                editConfig.taskMedicalId = row.id;
                editConfig.updateRemark = row.updateRemark || '';
                editConfig.editable = false;
                taskDetail(row.id).then((resonse: any) => {
                    let records = resonse.data;
                    for (let i = 0; i < records.length; i++) {
                        filesConfig[ records[i]['id'] ] = records[i]['attachmentList'];
                        updateFilesConfig[ records[i]['id'] ] = records[i]['updateAttachmentList'];
                    }
                    editConfig.tableData = records;
                    fullScreen.value =true
                    showModal.value =true
                });
            };
            let initSubUserList = ()=>{
                if(canSubmit){
                    fetList().then((res:any)=>{
                        forwardData.subUserData = res.data;
                    })
                }else{
                    forwardData.subUserData = [];
                }
            };
            const forwardData = reactive({
                editing: false,
                taskMedicalId:'',
                subUserSelect:[],
                subUserData: [] as any[],
            });
            const forwardEvent = (row:any) =>{
                forwardData.taskMedicalId = row.id;
                forwardData.subUserSelect = row.subUserList? row.subUserList.map((item:any) =>item.id):[];
                forwardData.editing = true;
            };
            const submitForward = ()=>{
                exeForward(forwardData.subUserSelect,forwardData.taskMedicalId).then((res:any)=>{
                    if(res.code===0){
                        getTableData();
                        forwardData.editing = false;
                    }
                })
            };
            const downData = reactive({
                editing: false,
                taskMedical:{} as any,
                filterName:'',
                villageAllList:[] as any[],
                villageList:[] as any[],
                villageSelect:[] as string[],
                page: reactive({
                    currentPage: 1,
                    pageSize: 10,
                    totalResult: 0,
                }) as PageValue,
                itemList:[] as any[],
                itemIdSelect:[] as any[],
                submitIng:false
            });
            const xTableVillage= ref({} as VxeTableInstance);
            const initVillageList=()=>{
                downTaskVillages().then((res:any)=>{
                    if(res.code===0){
                        downData.villageAllList = res.data;
                        downData.villageList = res.data.slice(0,downData.page.pageSize);
                        downData.page.totalResult = res.data.length;
                    }
                })
            };

            const downEvent = (row:any) =>{
                downData.taskMedical = row;
                downData.villageSelect = [];
                downTaskItems(row.taskId).then((res:any)=>{
                    if(res.code===0){
                        downData.itemList = res.data;
                    }
                })
                downData.editing = true
            };
            const searchEvent = ()=>{
                downData.page.currentPage = 1;
                let allList:any[] = downData.villageAllList.filter((item:any)=>{
                    return !downData.filterName || item.compName.indexOf(downData.filterName) > -1
                });
                downData.villageList = allList.slice(0,10)
                downData.page.totalResult = allList.length;
                initSelect();
            };
            const initSelect =()=>{

                // let selectedList = downData.villageList.filter(item=>downData.villageSelect.indexOf(item.id) > -1);
                // $refs.xTableVillage.setCheckboxRow(selectedList, true)

                // xTableVillage.setCheckboxRow(selectedList, true)
            }
            const villagePageChange=(args:any)=>{
                downData.page.pageSize = args.pageSize;
                downData.page.currentPage = args.currentPage;
                let allList = downData.villageAllList.filter((item:any)=>{
                    return !downData.filterName || item.compName.indexOf(downData.filterName) > -1
                });
                downData.villageList = allList.slice((args.currentPage-1)*args.pageSize,args.currentPage*args.pageSize)
                downData.page.totalResult = allList.length;
                initSelect();
            };

            const selectAllChangeEvent = ({ checked, $event }:any)=>{
                const records = downData.villageList;
                for(let i=0;i<records.length;i++){
                    let record = records[i];
                    let index = downData.villageSelect.indexOf(record.id);
                    if(checked){
                        if(index === -1)downData.villageSelect.push(record.id)
                    }else{
                        if(index >-1) downData.villageSelect.splice(index, 1);
                    }
                }
            };
            const selectChangeEvent = ({ checked, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }:any)=>{
                let index = downData.villageSelect.indexOf(row.id);
              if(checked){
                  if(index === -1)  downData.villageSelect.push(row.id)
              }else{
                  if(index >-1) downData.villageSelect.splice(index, 1);
              }
            };
            const selectAllItemChangeEvent = ({ checked, $event }:any)=>{
                const records = downData.itemList;
                for(let i=0;i<records.length;i++){
                    let record = records[i];
                    let index = downData.itemIdSelect.indexOf(record.id);
                    if(checked){
                        if(index === -1)downData.itemIdSelect.push(record.id);
                    }else{
                        if(index >-1) downData.itemIdSelect.splice(index, 1);
                    }
                }
            };
            const selectItemChangeEvent = ({ checked, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }:any)=>{
                let itemId = row.id;
                let index = downData.itemIdSelect.indexOf(itemId);
                if(checked){
                    if(index === -1)  downData.itemIdSelect.push(itemId)
                }else{
                    if(index >-1) downData.itemIdSelect.splice(index, 1);
                }
            };
            const downSubmit = ()=>{
                if(downData.submitIng)return;
                let params = {
                    taskItemIdList:downData.itemIdSelect,
                    compIdList:downData.villageSelect
                }
                if(params.compIdList.length && params.taskItemIdList.length){
                    downData.submitIng = true;
                    downTask(params,downData.taskMedical.taskId).then((res:any)=>{
                        if(res.code===0){
                            getTableData();
                            downData.submitIng = false;
                            downData.editing = false;
                            VXETable.modal.message({ content: "下发卫生室成功,请在左侧卫生室任务菜单查看详情", status: "success" });
                        }
                    })
                }
            };
            // 通用行合并函数（将相同多列数据合并为一行）
            const mergeRowMethod = ({ row, _rowIndex, column, visibleData }:any) => {
                const fields = ["parentId"];
                const cellValue = row[column.property];
                if (cellValue && fields.includes(column.property)) {
                    const prevRow = visibleData[_rowIndex - 1];
                    let nextRow = visibleData[_rowIndex + 1];
                    if (prevRow && prevRow[column.property] === cellValue) {
                        return { rowspan: 0, colspan: 0 };
                    } else {
                        let countRowspan = 1;
                        while (nextRow && nextRow[column.property] === cellValue) {
                            nextRow = visibleData[++countRowspan + _rowIndex];
                        }
                        if (countRowspan > 1) {
                            return { rowspan: countRowspan, colspan: 1 };
                        }
                    }
                }
            };
            let selectRow:any = null;
            let currentRow:any = null;
            let filesConfig :any = {};
            let updateFilesConfig :any = {};
            let delFilesConfig:any[] = [];
            // 表格监听
            const cellClick = ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex,
                                   triggerRadio, triggerCheckbox, triggerTreeNode, triggerExpandNode, $event }:any) => {
                selectRow = row;

            };

            // 文件上传
            let onSuccess = (response:any, file:any, fileList:any[]) => {
                addRowFile(response);
            };
            let onRemove = (file:any,fileList:any[]) => {
                console.log(file)
                removeRowFile(file);
            };
            // 文件上传
            let onUpdateFileSuccess = (response:any, file:any, fileList:any[]) => {
                addRowUpdateFile(response);
            };
            let onUpdateFileRemove = (file:any,fileList:any[]) => {
                removeRowUpdateFile(file);
            };
            let handlePictureCardPreview = (file:any)=>{
                 if(file.response) file = file.response.data[0]
                if(file.attType && file.attType.indexOf('image')>-1){
                    dialogImageUrl.value = file.url;
                    dialogVisible.value = true;
                }else if(file.attType && file.attType.indexOf('video')>-1){
                    dialogImageUrl.value = "";
                    dialogVideoUrl.value = file.url;
                    dialogVisible.value = true;
                }else{
                    window.open(file.url)
                }
            };
            let beforeAvatarUpload = (file:any)=>{
                currentRow = selectRow;
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!isLt2M) {
                    alert('上传文件大小不能超过 10MB!')
                    return
                }
                return isLt2M
            };
            let  addRowFile = (response:any) =>{
                if(response.code !== 0){
                    ElMessage({ message: response.msg, type: "error" });
                    return
                }
                let rowId = response.data[0]['rowId'] || currentRow["id"];
                if(filesConfig[rowId]){
                    filesConfig[rowId].push(response.data[0])
                }else{
                    filesConfig[rowId] = response.data
                }
            };

            let  addRowUpdateFile = (response:any) =>{
                let rowId = response.data[0]['rowId'] || currentRow["id"];
                if(updateFilesConfig[rowId]){
                    updateFilesConfig[rowId].push(response.data[0])
                }else{
                    updateFilesConfig[rowId] = response.data
                }
            };
            let removeRowFile = (file:any) => {
                let url = '';
                if (file.response) {
                    url = file.response.data[0].url;
                } else if (file) {
                    url = file.url;
                }
                for (let rowId in filesConfig) {
                    let i = filesConfig[rowId].length;
                    while (i){
                        i--
                        if(filesConfig[rowId][i]['url'] == url){
                             if(filesConfig[rowId][i]['id'])delFilesConfig.push(filesConfig[rowId][i]['id']);
                             filesConfig[rowId] = filesConfig[rowId].filter((file:any)=>file['url'] !== url);
                            return
                        }
                    }
                }
            };
            let removeRowUpdateFile = (file:any) => {
                let url = '';
                if (file.response) {
                    url = file.response.data[0].url;
                } else if (file) {
                    url = file.url;
                }
                for (let rowId in updateFilesConfig) {
                    let i = updateFilesConfig[rowId].length;
                    while (i){
                        i--
                        if(updateFilesConfig[rowId][i]['url'] == url){
                            if(updateFilesConfig[rowId][i]['id'])delFilesConfig.push(updateFilesConfig[rowId][i]['id']);
                            updateFilesConfig[rowId] =  updateFilesConfig[rowId].filter((file:any)=>file['url'] !== url);
                            return
                        }
                    }
                }
            };
            // 暂时未用
            let updateRowFiles = (fileList:any[]) => {
                var files = [];
                for (var i = 0; i < fileList.length; i++) {
                    if (fileList[i].response) {
                        files.push(fileList[i].response.data[0]);
                    } else if (fileList[i]) {
                        files.push(fileList[i]);
                    }
                }
                filesConfig[currentRow["id"]] = files;
            };

            let dialogVisible = ref(false);
            let dialogImageUrl = ref('');
            let dialogVideoUrl = ref('');
            let submiting = ref(false);
            const storeEvent = (event:any) =>{
                submitEvent(true);
            };
            const submitEvent = (temStore:any) =>{
                if(temStore != true)temStore = false;
                let selectRecords = editConfig.tableData;
                for (var i = 0; i < selectRecords.length; i++) {
                    if(!temStore && !selectRecords[i]["reportResult"] ){
                        ElMessage({
                            type: 'error',
                            message: '第'+ (i+1) + '个检查项未选择结果'
                        });
                        return
                    }
                    selectRecords[i]["attachmentList"] = filesConfig[selectRecords[i]["id"]] || [];
                    selectRecords[i]["updateAttachmentList"] = updateFilesConfig[selectRecords[i]["id"]] || [];
                };
                submiting.value = true
                let params = {
                    itemRuns:selectRecords,
                    delAttachmentIds:delFilesConfig
                }
                exeTask(params, editConfig.taskMedicalId,!!temStore).then(
                    (response: any) => {
                        if (response.code === 0) {
                            showModal.value =false
                            VXETable.modal.message({ content: temStore?"暂存申报成功":"申报成功", status: "success" });
                            getTableData();
                            store.commit("setWorkTotal");
                        }
                        submiting.value = false
                    }
                );

            };
            return {
                canSubmit,
                userCompType,
                table,
                pageChange,
                page,
                formatTime,
                formatState,
                formatSubUserList,

                config,

                showModal,
                fullScreen,
                editConfig,
                editEvent,
                viewEvent,

                forwardData,
                forwardEvent,
                submitForward,


                downData,
                downEvent,
                searchEvent,
                xTableVillage,
                villagePageChange,
                selectAllChangeEvent,
                selectChangeEvent,
                selectAllItemChangeEvent,
                selectItemChangeEvent,
                downSubmit,

                xTable1,
                mergeRowMethod,
                cellClick,

                onSuccess,
                onRemove,
                onUpdateFileSuccess,
                onUpdateFileRemove,
                handlePictureCardPreview,
                beforeAvatarUpload,


                dialogVisible,
                dialogImageUrl,
                dialogVideoUrl,
                storeEvent,
                submitEvent,
                submiting

            };
        },
    });
